export { default } from "./profile-inactive";
